<ng-template #loadingAvatar>
    <span class="avatar-block-icon avatar-loading" [ngClass]="classMapping" animated>
    </span>
    <span *ngIf="!iconOnly" class="avatar-block-content avatar-loading">
        <span class="avatar-block-text">
            <span *ngIf="!titleRef && !descriptionRef"></span>
            <span *ngIf="titleRef"></span>
            <span *ngIf="descriptionRef"></span>
        </span>
    </span>
</ng-template>

<ng-container *ngIf="!isLoadingInitialData; else loadingAvatar">
    <span class="avatar-block-icon"
          [ngClass]="classMapping"
          [matBadge]="badge > 9 ? '9+' : badge"
          [matBadgeHidden]="badge === 0">
        <ng-container [ngSwitch]="iconType">
            <span *ngSwitchCase="iconTypes.IMG" [ngClass]="classMapping" class="avatar-block-image">
                <img *ngIf="iconImage && inVirtualScroll"
                     alt="{{ 'Avatar image' }}"
                     [src]="iconImage"
                     (error)="iconType = iconTypes.INITIALS; iconImage = null"/>
                <img *ngIf="iconImage && !inVirtualScroll"
                     alt="{{ 'Avatar image' }}"
                     [ngSrc]="iconImage"
                     [fill]="true"
                     (error)="iconType = iconTypes.INITIALS; iconImage = null"/>
            </span>
            <mat-icon *ngSwitchCase="iconTypes.SVG" [svgIcon]="svgIcon"></mat-icon>
            <mat-icon *ngSwitchCase="iconTypes.ICON">{{ icon }}</mat-icon>
            <span *ngSwitchCase="iconTypes.INITIALS" class="initials">{{ initials }}</span>
        </ng-container>
        <ng-content select="[unreadDot]"></ng-content>
    </span>
    <span *ngIf="!iconOnly" class="avatar-block-content">
        <span class="avatar-block-text">
            <span class="avatar-block-title-row">
                <ng-content select="[avatarTitle]"></ng-content>
                <ng-content select="[avatarTitleSuffix]"></ng-content>
            </span>
            <ng-content select="[avatarDescription]"></ng-content>
            <ng-content></ng-content>
        </span>
    </span>
    <ng-content select="mat-chip"></ng-content>
</ng-container>
